import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading || user === null) {
        return (
            <div className="min-h-screen bg-[#020617] flex items-center justify-center text-slate-400">
                <Loader2 className="animate-spin mr-2" /> Chargement…
            </div>
        );
    }
    if (!user) return <Navigate to="/tms/login" replace />;
    return children;
}
